<div class="dialog-pqr">
  <div class="header">
    <h2 mat-dialog-title>Valores do padrão de qualidade de referência - PQR</h2>

    <mat-dialog-actions>
      <button mat-dialog-close class="close-x-button">×</button>
    </mat-dialog-actions>
  </div>

  <mat-dialog-content>
    <h1 class="title">Alimentação escolar</h1>
    <div class="panel">
      <app-tabela
        ngSkipHydration
        class="table-component"
        [cabecalhoCustomizado]="true"
      >
        <ng-container cabecalho>
          <tr>
            <th class="table-header" rowspan="2" style="width: 16%">Etapa/segmento/modalidade</th>
            <th class="table-header" rowspan="2" colspan="1" style="width: 5%">Número de dias letivos</th>
            <th class="table-header" colspan="2" style="width: 25%">Per Capita (R$)</th>
            <th class="table-header" colspan="2" style="width: 25%">Per Capita (R$) (Indígenas e Quilombolas)</th>
          </tr>
          <tr>
            <th class="table-header" style="width: 3%">Parcial</th>
            <th class="table-header" style="width: 3%">Integral</th>
            <th class="table-header" style="width: 3%">Parcial</th>
            <th class="table-header" style="width: 3%">Integral</th>
          </tr>
        </ng-container>
        <ng-container corpo>
          <ng-container *ngFor="let dados of dadosTabela; index as i">
            <tr *ngIf="i % 2 === 0">
              <td class="table-cell align-center">{{ dados.etapaEnsino.descricao }}</td>
              <td class="table-cell align-center">{{ dados.numeroDiasLetivosAno }}</td>
              <td class="table-cell">
                <input
                  class="display-input"
                  value="{{ dados.valorRefeicao }}"
                />
              </td>
              <td class="table-cell">
                <input
                  class="display-input"
                  *ngIf="i !== 10"
                  value="{{ dadosTabela[i+1].valorRefeicao }}"
                />
              </td>
              <td class="table-cell">
                <input
                  class="display-input"
                  value="{{ dados.valorRefeicaoIndigenaQuilombola }}"
                />
              </td>
              <td class="table-cell">
                <input
                  class="display-input"
                  *ngIf="i !== 10"
                  value="{{ dadosTabela[i+1].valorRefeicaoIndigenaQuilombola }}"
                />
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </app-tabela>
    </div>

  </mat-dialog-content>

  <mat-dialog-actions class="footer">
    <button class="close-button" mat-dialog-close>Fechar</button>
  </mat-dialog-actions>
</div>
